import { v4 as uuid } from "uuid";
import React, { useEffect, useState} from "react";

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'
import { PaginationModel } from '@/models/Pagination'
import { FolderIcon, StopIcon as StopIconEnabled } from '@heroicons/react/20/solid'
import {StopIcon} from '@heroicons/react/24/outline'
import {IconSquare, IconSquareCheck} from '@tabler/icons-react';

export function MapTree({ ...props }) {
    const [isOpen, setOpen] = useState( (props?.selectedMap) ?props?.selectedMap : (props.selectedItem) ? props.selectedItem : []);
    
    
    const level = (props?.level >= 0) ? props?.level : 1;
    let parentKey = (props.parentKey) ? props.parentKey : "";
    
    let indexKey = "";
    let  data = null;
    if(props?.firstItem) {
         data = new Array(props?.firstItem);
    } else if(props.data) {
        data = props.data;
    }
    
    
    if(!(data)) {
        return (<></>);
        
    }
    
    const checkIsOpen =((item) => {
        if(!Array.isArray(isOpen)) {
            if(isOpen && isOpen?.path.indexOf(item.path) >= 0) {
                return true;
            } else {
                return false;
            }
        }
        return false;
    });

    const setEnabled =((event, item, index = null) => {
        let newItem = null;
        if(!item?.enabled) {
            newItem = {...item, enabled: true};
        } else {
            newItem = {...item, enabled: false};
        }
        
        if(props.setValue) {
          props.setValue(newItem, indexKey);
        }
    });
        
    const selectItem =((event, item, index = null, parentKey = "") => {
        if(props?.level > 1) {
            if(props?.parentIndexKey) {
                indexKey = props?.parentIndexKey; 
            }
            if(index) {
                indexKey = indexKey+".children["+index+']';
                if(props.setIndexKeyHandler) {
                    props.setIndexKeyHandler(indexKey);
                }
            }
        }
        
        if(event.target.getAttribute('data-type') == "selectionBox" || 
        event.originalTarget.parentElement.getAttribute('data-type') == "selectionBox") return false;
        
        if(item?.enabled === false) return false;
                
        event.stopPropagation();
        event.stopImmediatePropagation();
        const {level} = props;
        //if(level >= 0) {
                setOpen(item);
            //setOpen(item);
        //}
        if(props.selected) {
            let keyName = "";
            if(props.keyName) {
                keyName = props.keyName+'['+index+'].';
            }
            props.selected(item, isOpen, keyName, parentKey);
        }
        return false;
    });
let selected = null;
if(level > 0) {
    selected = isOpen[level-1];
}

    let icon = null;
const getIcon=((item) => {
    if(props?.icon) {
        let classNames = 'h-5 w-5 text-purple';
        let textColorNumber = '300';
        if(props?.level == 3) {
            classNames = 'h-5 w-5 text-blue';
            textColorNumber = '400';
        }else if(props?.level == 4) {
            classNames = 'h-5 w-5 text-green';
            textColorNumber = '400';
        }
        if(item && !item.enabled) {
            textColorNumber = '100';
            
        }
            classNames = classNames+"-"+textColorNumber;;
        
        icon  = React.createElement( props?.icon, {className: classNames});
        return icon;
    }
    
});

const createParentIndexKey=((index = null) => {
    let parentIndexKey = '';
    if(level > 1 && index) {
        parentIndexKey = 'children['+index+']';
    }
    return parentIndexKey;
})    

const getIconClassNames=(() => {
        let classNames = 'h-5 w-5 text-purple-300';
        if(props?.level == 3) {
            classNames = 'h-5 w-5 text-blue-400';
        }else if(props?.level == 4) {
            classNames = 'h-5 w-5 text-green-300';
        }
        
        return classNames;
}); 

const checkChildrenClosed=(item, level) => {
    let retVal = true;
    
    if(props?.childrenClosed !== undefined && props?.childrenClosed === true) {
        retVal = false;
        if(level <=1 || (item?.ref && item?.ref != null && props.selectedItem && props.selectedItem?.path && props.selectedItem?.path  != "" && props.selectedItem?.path.includes(item?.ref.trim()))) {
            retVal = true;
        } else 
            if(level <=1 || (props.selectedItem && props.selectedItem?.pathkeys && props.selectedItem?.pathkeys  != "" && props.selectedItem?.pathkeys.includes(item?.key.trim()))) {
                retVal = true;
            } else if(props?.selectedItem && props.selectedItem?.key == item?.key && props.selectedItem.children.length > 0) {
                retVal = true;
            }
        
if(!retVal && isOpen && isOpen?.key && item?.key === isOpen?.key) {
    retVal = true;
}            
            
    }
    
    return retVal;
}

const getParentKey = (item) => {
    let retVal = parentKey;
    if(item.ref) {
        if(retVal != "") {
            retVal += ".";
        }
        retVal += item.ref.trim();
    } else if(item.pathkeys) {
        retVal = item.pathkeys;
    }
    return retVal;
}

  return (

    <div key={uuid().slice(0, 8)} className={"flex items-center justify-between border-t border-gray-200 bg-white  " +
    (props.className) ? props.classname : ""}>
        {Array.isArray(data) &&
            data.map((item, index) => (
                <>
                <div key={uuid().slice(0, 8)} className={"flex flex-row justify-start cursor-pointer "+((level > 0) ? "text-sm max-h-6" : "max-h-7 h-7 ")} level={level}
                onClick={() => selectItem(event, item, index, getParentKey(item))}
                >
                
                {(() => {
                    if(level > 1 && props.withEnable && (!item?.enabled || item?.enabled === false)) {
                        return (<><IconSquare key={uuid().slice(0, 8)} className="h-5 w-6 text-black-200 flex-no-shrink " data-type="selectionBox" width="50px" height="50px" onClick={() => setEnabled(event, item, index)}/></>);
                    } else if(level > 1 && props.withEnable) {
                        return (<><IconSquareCheck key={uuid().slice(0, 8)} className="h-5 w-6  flex-no-shrink " data-type="selectionBox" width="50px" height="50px" onClick={() => setEnabled(event, item, index)}/></>);
                        
                    }
                })()}            
                
                {(() => {
                if(level > 1 && props?.icon) { 
                    return (<>{getIcon(item)}</>);
                } else if(level > 1){
                    return (<FolderIcon className={getIconClassNames()} />);
                }        
                })(item)}
                
                {props?.renderItem && 
                    props.renderItem(item, props.selectedItem)
                }
                {!props?.renderItem &&             
                    <span  className={"truncate max-h-7 h-7 overflow-hidden "+((item?.enabled === false) ? 'text-black/50' : '')+" "+((props.selectedItem?.key == item?.key)? "font-bold" : "")}>{(item?.name && item?.name != "") ? item?.name : item?.name}</span>
                }
                </div>
                
                {item?.children  && ((item?.enabled == true) && (checkChildrenClosed(item, level))) &&  
                    <MapTree key={uuid().slice(0, 8)} parentKey={getParentKey(item)} selectedItem={props?.selectedItem} parentIndexKey={createParentIndexKey(index)} data={item?.children.get()} withEnable={props.withEnable} setValue={props?.setValue} getFormValues={props?.getFormValues}  rights={props?.rights} level={level+1} icon={props?.icon}  classname={(level > 1 ? "ml-5" : "")+" "+((item.id == selected?.id) ? "" : "hidden")} selected={props?.selected} selectedMap={isOpen} keyName={(props?.keyName) ? props?.keyName+'['+index+'].children' : 'children'} parentIndex={index} childrenClosed={props?.childrenClosed}
                    renderItem={props?.renderItem}
                    />
                }
                
                </>
            ))
        }
        {!Array.isArray(data) &&
            Object.keys(data).map((childKey) => (
                <>
        <div key={uuid().slice(0, 8)} className="max-h-6 flex flex-row justify-start cursor-pointer text-sm" level={level}
        onClick={() => selectItem(event, props?.data[childKey], childKey)}>
                {(() => {
                    if(level > 0 && props.withEnable && !item?.enabled) {
                        return (<><IconSquare key={uuid().slice(0, 8)} className="h-7 w-6 text-black-200 flex-no-shrink " data-type="selectionBox" width="100px" height="100px" onClick={() => setEnabled(event, item, childKey)}/></>);
                    } else if(level > 0 && props.withEnable) {
                        return (<><IconSquareCheck key={uuid().slice(0, 8)} className="h-7 w-6 text-black-200 flex-no-shrink " data-type="selectionBox" width="100px" height="100px" onClick={() => setEnabled(event, item, childKey)}/></>);
                        
                    }
                })()}            
                
                {(() => {
                if(props?.icon) { 
                    return (<>{getIcon(item)}</>);
                } else {
                    return (<FolderIcon className={getIconClassNames()} />);
                }        
                })()}  
                
                {props?.renderItem && 
                    props.renderItem(item, props.selectedItem)
                }
                {!props?.renderItem &&             
                          
                    <span className={"truncate "+(((isOpen && ((selected && selected?.id == props?.data[childKey].id) || checkIsOpen(props?.data[childKey])) ) ? "font-bold" : ""))+((props?.data[childKey]?.enabled) ? ' text-black/50' : ' text-green')}>{props?.data[childKey]?.name}</span>
                }
        </div>
        {props?.data[childKey]?.children  && ((props?.data[childKey].id == selected?.id) || checkIsOpen(props?.data[childKey])) &&
        checkChildrenClosed(item, level) &&
            <MapTree key={(isOpen) ? isOpen.key : childKey} data={props?.data[childKey]?.children} rights={props?.rights} level={level+1} isOpen={true} classname={"ml-2.5"+" "} selected={props?.selected} selectedMap={isOpen}  parentIndex={childKey} childrenClosed={props?.childrenClosed}/>
        }
        </>
        ))
        }
    </div>

    )    
}
